export const FETCH_UNASSIGNED_PROVIDER_LIST_REQUEST =
  "FETCH_UNASSIGNED_PROVIDER_LIST_REQUEST";
export const FETCH_UNASSIGNED_PROVIDER_LIST_SUCCESS =
  "FETCH_UNASSIGNED_PROVIDER_LIST_SUCCESS";
export const FETCH_UNASSIGNED_PROVIDER_LIST_FAILURE =
  "FETCH_UNASSIGNED_PROVIDER_LIST_FAILURE";